import { Component } from '@angular/core';

@Component({
  selector: 'tt-ultra-sonic-classes-view',
  templateUrl: './ultra-sonic-classes-view.component.html',
  styleUrls: ['./ultra-sonic-classes-view.component.css']
})
export class UltraSonicClassesViewComponent {

}
